import Filter from "./Filter";
import Parse from "../Parse";

const Logger = (...messages) => {
    const currentUser = Parse.User.current();
    const webSettings = currentUser.get("websetting");
    if(webSettings == undefined || !webSettings || !Filter.isJSON(webSettings)) {
        return;
    }
    const settings = JSON.parse(webSettings);
    if(settings.debug === true){
        console.log(messages);
    }
}
export default Logger;